'use client';

import { Skeleton } from '@picsart/design-system/components/Skeleton';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import useStyles from './styles';

interface MasonrySkeletonProps {
  itemCount: number;
}

const getRandomHeight = () => Math.floor(Math.random() * 101) + 200;

const MasonrySkeleton = ({ itemCount }: MasonrySkeletonProps) => {
  const classes = useStyles();
  const items = Array.from({ length: itemCount }).map((_, index) => ({ id: index, height: getRandomHeight() }));

  return (
    <div className={classes.grid}>
      {items.map(item => (
        <Skeleton key={item.id} className={classes.card} height={item.height} width="100%" borderRadius={CornerRadius.r8} />
      ))}
    </div>
  );
};

export default MasonrySkeleton;
